/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserRequest } from '../models/CreateUserRequest';
import type { GlobalUser } from '../models/GlobalUser';
import type { UpdateUserRequest } from '../models/UpdateUserRequest';
import type { User } from '../models/User';
import type { UserSettings } from '../models/UserSettings';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * Get list of users (for user's company)
     * @returns User Success
     * @throws ApiError
     */
    public static getUsers({
        limit,
        offset,
        dataAccessGroupIds,
        roleIds,
        search,
        includeExternalDetails,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Data Access Group
         */
        dataAccessGroupIds?: Array<number>,
        /**
         * Role
         */
        roleIds?: Array<number>,
        /**
         * Search by name
         */
        search?: string,
        /**
         * Include Cognito and Quicksight details
         */
        includeExternalDetails?: boolean,
    }): CancelablePromise<Array<User>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user',
            query: {
                'limit': limit,
                'offset': offset,
                'dataAccessGroupIds': dataAccessGroupIds,
                'roleIds': roleIds,
                'search': search,
                'includeExternalDetails': includeExternalDetails,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * @returns User Success
     * @throws ApiError
     */
    public static createUser({
        requestBody,
    }: {
        requestBody: CreateUserRequest,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get current user
     * @returns User Success
     * @throws ApiError
     */
    public static getCurrentUser({
        login,
    }: {
        /**
         * flag to log audit message
         */
        login?: boolean,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/current',
            query: {
                'login': login,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update user profile
     * @returns User Success
     * @throws ApiError
     */
    public static updateCurrentUser({
        requestBody,
    }: {
        /**
         * User settings
         */
        requestBody: {
            settings?: UserSettings;
        },
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/current',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get user details
     * @returns User Success
     * @throws ApiError
     */
    public static getUser({
        userId,
    }: {
        userId: number,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update user data
     * @returns User Success
     * @throws ApiError
     */
    public static updateUser({
        userId,
        requestBody,
    }: {
        userId: number,
        requestBody: UpdateUserRequest,
    }): CancelablePromise<User> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete User
     * @returns any Success
     * @throws ApiError
     */
    public static deleteUser({
        userId,
    }: {
        /**
         * User ID
         */
        userId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export list of users
     * @returns binary Success
     * @throws ApiError
     */
    public static exportUsers(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * reset user password
     * @returns any Success
     * @throws ApiError
     */
    public static resetUserPassword({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/resetPassword',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Quick Sight User
     * @returns any Success
     * @throws ApiError
     */
    public static createQuickSightUser({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/quicksight',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get users quicksight status
     * @returns string Success
     * @throws ApiError
     */
    public static getUsersQuicksightStatus(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/quicksight/status',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * create Cognito User
     * @returns any Success
     * @throws ApiError
     */
    public static createCognitoUser({
        id,
    }: {
        /**
         * User ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/{id}/cognito',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * update User Company
     * @returns any Success
     * @throws ApiError
     */
    public static updateUserCompany({
        id,
        requestBody,
    }: {
        /**
         * User ID
         */
        id: number,
        requestBody: {
            targetCompanyId: number;
        },
    }): CancelablePromise<{
        user?: GlobalUser;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/user/{id}/company',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
